/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TIMER_VAR_NAME = feature.getSettingValue('TIMER_NAME');
    const TIMER_NAME = `timer_${TIMER_VAR_NAME}`;

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        // template: `dim ${VARNAME} as ${DATATYPE}=${defaultValue}`,
        template: `
const ${TIMER_NAME}= {
    timer: 0,
    startTs: 0,
};
`,
    });

    blocks.push({
        location: 'RESET_VARIABLES',
        blockType: BlockType.CODE,
        template: `
clearTimeout(${TIMER_NAME}.timer);
${TIMER_NAME}.timer = 0;
${TIMER_NAME}.startTs = 0;
        `,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function timer_interruption_handler_${TIMER_NAME}(timer) {
    /****timer_interruption_handler_${TIMER_NAME}****/
}`,
    });

    blocks.push({
        location: `var_${TIMER_VAR_NAME}_set`,
        blockType: BlockType.CODE,
        template: `
if (${TIMER_NAME}_timer_repeat) {
    clearTimeout(${TIMER_NAME}.timer);
    ${TIMER_NAME}.timer = 0;
    ${TIMER_NAME}.startTs = 0;
}
if (value > 0) {
    ${TIMER_NAME}_timer_start(value);
} else {
    ${TIMER_NAME}.timer = 0;
    ${TIMER_NAME}.startTs = 0;
}
        `,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function ${TIMER_NAME}_timer_complete() {
    /****${TIMER_NAME}_timer_complete****/
    

    if (${TIMER_NAME}_timer_repeat) {
        ${TIMER_NAME}_timer_start(${TIMER_VAR_NAME});
    } else {
        ${TIMER_NAME}.timer = 0;
        ${TIMER_NAME}.startTs = 0;
        ${TIMER_VAR_NAME} = 0;
    }
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function ${TIMER_NAME}_timer_start(value) {
    if (isNaN(value)) {
        return;
    }
    clearTimeout(${TIMER_NAME}.timer);
    ${TIMER_NAME}.timer = 0;
    ${TIMER_NAME}.startTs = new Date().getTime();
    ${TIMER_NAME}.timer = setTimeout(() => {
        ${TIMER_NAME}_timer_complete()
    }, value * 1000);
}`,
    });

    return blocks;
};
